import cuid from 'cuid';
import { localStorage } from 'dibs-browser-storage';
import { cookieJarConstants, getBuyerId } from 'dibs-cookie-jar';

export function getGuestId(): string {
    // As of Apple ITP 2.1, guestIds are stored in localStorage, not cookie
    // See: https://1stdibs.atlassian.net/browse/ENGAGE-979
    return localStorage.getItem(cookieJarConstants.GUEST_ID) || '';
}

// need to convert dibs-browser-storage to ts
export function deleteGuestId(): $TSFixMe {
    return localStorage.deleteItem(cookieJarConstants.GUEST_ID);
}

export function handleGuestId(): void {
    if (!getBuyerId(document.cookie) && !getGuestId()) {
        localStorage.setItem(cookieJarConstants.GUEST_ID, cuid());
    }
}
